import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {PhoneNumberComponent} from './phone-number.component';


@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PhoneNumberComponent
  ],
  exports: [
    PhoneNumberComponent
  ],
  providers: []
})
export class PhoneNumberModule {
}
